"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bearDialogueData = exports.finishedTasksMonTookDialogueFactory = exports.firstTimeHandingInFlowerDialogue = exports.talkAfterTutorialDialogue = exports.explainShovelDialogue = exports.houseHagglingDialogue = exports.startGameDialogue = void 0;
function startGameDialogue(username) {
    return {
        npcComments: [
            `Hi ${username}! Welcome to SNES Crossing.`,
            `I understand you're from out of town, but you plan on living here right?`,
        ],
        npcQuestion: `Which means you'll need a house! Right!?`,
        responses: [{
                response: 'Yes.',
                reply: { npcComments: ['Great follow me!'] },
            }, {
                response: 'No.',
                reply: { npcComments: ['Too bad follow me.'] },
            }]
    };
    // play animation of holding up shovel so player knows they got the shovel.
}
exports.startGameDialogue = startGameDialogue;
const haggleDialogue = {
    // doing the haggling for the house.
    npcQuestion: 'Ahem.. anyway.. do you want the deal?',
    responses: [{
            response: 'Yes.',
            reply: {
                npcComments: [
                    'Great!',
                    `Wait you don't have any honey!!?`,
                    `Why didn't you say so!? You are a terrible person.`,
                    `Because I'm such a nice guy, I'll give you a loan.`,
                    `You'll need a job to pay me back, so starting today you're my employee.`,
                    `Here's a shovel.`,
                ]
            },
        }, {
            response: 'No.',
            reply: {
                npcComments: [
                    'Too bad!!!',
                    `I already know you don't have any honey to your name!`,
                    'Frankly, you need me to survive in this town.',
                    'So you will take this house as a loan and pay me back.',
                    'Starting today you become my errand boy.',
                    `Here's a shovel.`,
                ]
            }
        }]
};
exports.houseHagglingDialogue = {
    npcComments: [
        `And here it is! The finest house we have here!`,
        `Since you seem like a good kid, I'll give you a deal.`
    ],
    npcQuestion: `It’s all yours for the low price of 100 gallons of honey, what do you say?`,
    responses: [{
            response: 'Honey? You mean bells right?',
            reply: {
                npcComments: [
                    'No, no, no, no. Let me explain.',
                    'See, this town happens to be full of hungry honey bears.',
                    'Being the shrewd businessman I am, I’ve monopolized all the bee colonies!',
                    `The town's bee population has suffered greatly, which makes me the only honey supplier!`,
                    'MUAHAHAHAHAHAHAHA!!!!'
                ],
                singleResponse: {
                    response: '...',
                    reply: haggleDialogue,
                },
            },
        }, {
            response: 'Uhhh...what? honey?',
            reply: {
                npcComments: [
                    'Yes that’s right, honey! Sweet, sticky, lovely, delicious honey!',
                    'See, this town happens to be full of hungry honey bears.',
                    'Being the shrewd businessman I am, I’ve monopolized all the bee colonies!',
                    `The town's bee population has suffered greatly, which makes me the only honey supplier!`,
                    'MUAHAHAHAHAHAHAHA!!!!'
                ],
                singleResponse: {
                    response: '...',
                    reply: haggleDialogue,
                },
            },
        }, {
            loopedDialogue: {
                playerResponses: [
                    'Do I get to see the inside at least?',
                    'Why?',
                    'Because why?',
                    'That\'s a terrible reason.',
                    'You should!',
                    'Why not!'
                ],
                npcReplies: [
                    "No.",
                    "Because.",
                    "I said so.",
                    `I don't care.`,
                    `Well I don't`
                ],
                finalNpcDialogue: [
                    'BECAUSE YOU MIGHT RUN OFF SOMEWHERE ON THE ISLAND BEFORE I EXPLAIN THE REST OF THE GAME.',
                    'NOW SHUT UP AND LISTEN TO MY GENIUS SCHEME AGAINST THE HONEY BEARS OF THIS ISLAND.',
                    'I HAVE COMMITED BUMBLE BEE GENOCIDE ON THIS ISLAND!',
                    'THEREFORE GRANTING ME A MONOPOLY ON HONEY!!',
                    'MUAHAHAHAHAHAHAHA!!!!'
                ],
                finalPlayerDialogue: {
                    response: '...',
                    reply: haggleDialogue,
                }
            },
        }],
};
exports.explainShovelDialogue = {
    // explain what the shovel is for.
    playerComment: 'Okay.. so what`s the shovel for?',
    npcComments: [
        `We don't want the bee population coming back, now do we?`,
        'So your first job is to go around this island and dig up any flowers you find.',
        `Open your inventory to equip your shovel.`,
        `To pick up items from the ground use the space bar.`,
    ],
    npcQuestion: 'Pick up the pedals and come talk to me. I`ll give you honey.',
    responses: [{
            response: 'Yes sir.',
        }, {
            loopBack: true,
            response: 'How do I equip my shovel?',
            reply: {
                npcComments: [
                    'Uhgg new employees are so annoying.',
                    'First, open your inventory by pressing the q or SHIFT key',
                    'Next navigate with the WASD or Arrow Keys, press the ENTER key when the shovel is selected.',
                    'Then finally, press ENTER again to equip it.',
                    `Don't forget to close your inventory the same way you opened it.`,
                    ['Now get to work!', `Now shoo!, there's work to do!`],
                ],
            },
        }, {
            loopBack: true,
            response: 'How do I dig up a flower?',
            reply: {
                npcComments: [
                    'Seriously? Do I need to explain how to use the bathroom too?',
                    'When your shovel is equipped, while facing a flower, press the ENTER key.',
                    ['Now get to work!', `Now shoo!, there's work to do!`],
                ],
            },
        },]
};
const shovelInstructionResponses = [
    {
        response: 'How do I equip my shovel?',
        reply: {
            npcComments: [
                `WHAT!? Why didn't you ask before!? Uhgg, new employees are so annoying.`,
                'First, open your inventory by pressing the q or SHIFT key',
                'Next navigate with the WASD or Arrow Keys, press the ENTER key when the shovel is selected.',
                'Then finally, press ENTER again to equip it.',
                `Don't forget to close your inventory the same way you opened it.`,
                ['Now get to work!', `Now shoo!, there's work to do!`],
            ],
        },
    }, {
        response: 'How do I dig up a flower?',
        reply: {
            npcComments: [
                `...Hiring you may have been a terrible mistake.`,
                'When your shovel is equipped, while facing a flower, press the ENTER key.',
                ['Now get to work!', `Now shoo!, there's work to do!`],
            ],
        },
    }, {
        response: 'What should I do with flower seeds?',
        reply: {
            npcComments: [
                `THROW THEM AWAY THIS INSTANT!!!!!!!!!!!`,
                `Perhaps if they happened to fall into a hole they'd grow a new flower in time.`,
                `That would be TERRIBLE! More flowers means more bumble bees!`,
                `More bumble bees means more honey that's NOT mine!`,
                `I can't have those pesky bugs devaluing my honey supply.`,
                'So whatever you do, DO NOT select the seeds in your inventory!',
                'If you do, ABSOLUTELY DO NOT select the PLANT option. ESPECIALLY in front of a hole.',
            ],
        }
    }
];
const netInstructionResponses = [{
        response: 'How do I catch a bee?',
        reply: {
            npcComments: [
                `Oh yes the elusive feat of capturing a mere bumble bee.`,
                '...',
                `How have you made it this far in life?`,
                'Just simply face the bee while your net is equipped and swing it by pressing ENTER.',
                `It's not rocket science kid.`
            ],
        },
    }];
function talkAfterTutorialDialogue(hasFlowerPedals, sellFlowerCallback) {
    const instructionDialogue = [{
            response: 'I want to shop',
            reply: {
                npcComments: [
                    'HAHAHAHAHAHAHAHHAHAHAHA!!!',
                    'HAHAHAHAHAHAHAHHAHAHA HAHAHAHAHAHAHAHAH!!!',
                ],
                singleResponse: {
                    response: '...',
                    reply: {
                        npcComments: [
                            `Oh.. you were serious...`,
                            `GO DO YOUR JOB AND EARN SOME HONEY, THEN I'LL OPEN MY SHOP FOR YOU!`,
                        ]
                    }
                }
            }
        },
        ...shovelInstructionResponses,
    ];
    if (!hasFlowerPedals) {
        return {
            npcQuestion: 'What are you doing! where are my flower pedals!?',
            responses: [{
                    response: `Oh right..`,
                }, ...instructionDialogue]
        };
    }
    else {
        return {
            npcQuestion: `Yes? What do you need?`,
            responses: [{
                    sellFlowersOption: sellFlowerCallback,
                }, ...instructionDialogue, {
                    response: 'Just saying hi.',
                    reply: {
                        npcComments: [`I don't have time for childish nonsense, get back to work!`]
                    }
                },]
        };
    }
}
exports.talkAfterTutorialDialogue = talkAfterTutorialDialogue;
exports.firstTimeHandingInFlowerDialogue = {
    npcComments: [
        `Ahh! Great job! Yes! This is exactly what I wanted.`,
        `I've noticed I still sometimes spot wild bees buzzing around.`,
        'This is indeed a problem for me, so here. Take this bug net.',
        `I can't have those bees around or else I may lose my honey monopoly`,
        `I will pay you in lots of honey for each bee you bring me!`,
        'Now go catch me some bees!'
    ],
};
const FirstTimeExplainingNetDialogue = {
    npcComments: [],
};
function finishedTasksMonTookDialogueFactory(openShopOption, sellFlowersOption, sellBumbleBeeOption) {
    //console.error('open shop option:', openShopOption)
    return {
        npcQuestion: `Yes? What do you need?`,
        responses: [
            { sellBumbleBeeOption },
            { sellFlowersOption },
            ...shovelInstructionResponses,
            ...netInstructionResponses,
        ]
    };
}
exports.finishedTasksMonTookDialogueFactory = finishedTasksMonTookDialogueFactory;
exports.bearDialogueData = {
    npcComments: ["Mr Took is hoarding all the honey.", "I'm hungry!!", "HE TOOK OUR NOMS", "Save the bees!", " I LOVE THE ENVIRONMENT! "]
};
//# sourceMappingURL=module.js.map